import { apiWrapper, apiCancel } from '../../wrapper'

export const initial = 'assesment'
const baseUrl = process.env.REACT_APP_SERVICE_ASSESMENT_URL
const appCode = process.env.REACT_APP_SERVICE_ASSESMENT_APPCODE
const outputType = 'json'
// Manajerial
export const AcManajerialList = '/Transaction/Managerial/list/'
export const AcManajerialCreate = 'Transaction/Managerial/create/'
export const AcManajerialData = 'Transaction/Managerial/acdata/'
export const AcManajerialDetail = 'Transaction/Managerial/acdetail/'
export const AcManajerialUpdate = 'Transaction/Managerial/update/'
export const AcManajerialEmployee = 'Transaction/Managerial/get_employee/'
export const AcManajerialPeriod = 'Transaction/Managerial/get_period/'
export const AcManajerialKinerja = 'Transaction/Managerial/get_performance/'
export const AcManajerialStankom = 'Transaction/Managerial/get_stankom/'
export const AcManajerialEmployeeDetail = 'Transaction/Managerial/get_employeedetail/'
export const AcManajerialLevelCompetence = 'Transaction/Managerial/get_competencelevel/'
export const ManajemenTalentaMatrix = '/Transaction/Laporan/get_matrix/'
export const ManajemenTalentaMatrixSearch = '/Transaction/Laporan/get_matrixsearch/'
export const GetEselon = 'Transaction/Laporan/get_eselon/'
export const GetPosition = 'Transaction/Laporan/get_position/'
export const GetMxEmpLists = 'Transaction/Laporan/get_mxemplist/'
export const JpmSearch = 'Transaction/Laporan/get_jpmsearch/'

//export const cancelToken = () => apiCancel
export const cancelToken = () => {
    return apiCancel()
}
export const apiRequest = async (method, route, data = { params: null, body: null, cancelToken: null }, needToken=true) => {
    if(needToken) {
        const thisTime = (Math.floor(Date.now()/1000))
        const expire = localStorage.getItem(initial + 'accessExpired')
        if(expire < thisTime) {
           await apiWrapper(baseUrl, initial, appCode, outputType, 'post', 'auth/getAccessToken/', data)
           .then(result => {
                localStorage.setItem(initial + 'accessToken', result.response.access_token)
                return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
            })
            .catch(result => {
                return Promise.reject('Tidak dapat mengambil accessToken');
            })
        } else {
            return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)        
        }
    }
    return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
}